import { ProductMtaModel } from "../mta/product-mta.model";
import { ProductModel } from "../product/product.model";

export class ProductMtaAgreementModel {
    public constructor(
        public product: ProductModel,
        public mtaList: Array<ProductMtaModel>,
        public onProceed: () => void,
        public onCancel: () => void
    ) { }
}
